<template lang="html">
<div>
  <div class="el-loading-mask is-fullscreen" v-if="isLoading">
		<div class="el-loading-spinner">
			<svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!---->
		</div>
	</div>
</div>

</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Loading",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.example.isLoading,
      apiLoading: (state) => state.example.apiLoading,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "./loading.scss";
</style>



// WEBPACK FOOTER //
// src/views/components/loading.vue